/**
 * SASS
 */
import "../scss/frontend.scss";
import "../img/wrapper.svg";
import "../img/freccia.svg";
import "../img/freccia-menu.svg";
import "../img/semicerchio.svg";

/*
 * campane JS
 */

// import printMe from './print.js'

import jQuery from "jquery";
import gsap from "gsap";

//import Swiper from "swiper/bundle";
import { Navigation } from "swiper/modules";
import Swiper from "swiper";
import "swiper/scss";
import "swiper/scss/mousewheel";
import "swiper/scss/navigation";

(function ($) {
  "use strict";

  $(document).ready(function () {
    // Comments

    $(".commentlist li").addClass("card mb-3");
    $(".comment-reply-link").addClass("btn btn-secondary");

    // Forms

    $(
      "select, input[type=text], input[type=email], input[type=password], textarea"
    ).addClass("form-control");
    $("input[type=submit]").addClass("btn btn-primary");

    // Pagination fix for ellipsis

    $(".pagination .dots").addClass("page-link").parent().addClass("disabled");

    $(".hamburger--collapse").on("click", function () {
      $(this).toggleClass("is-active");
      $("#overlay").toggleClass("open");
      $("body").toggleClass("no-scroll");
    });

    const mainNav = document.getElementById("main-nav");
    let lastScrollTop = 0;
    const delta = 5;
    const navbarHeight = mainNav.offsetHeight;
    const buffer = 50; // Imposta un buffer per evitare cambiamenti rapidi durante piccoli scroll
    
    function handleScroll() {
        const st = window.scrollY;
    
        if (Math.abs(lastScrollTop - st) <= delta) return;
    
        if (st > lastScrollTop && st > navbarHeight + buffer) { // Aggiunto buffer
            mainNav.style.top = "-100%";
            mainNav.classList.remove('bg-light');
        } else {
            if (st + window.innerHeight < document.documentElement.scrollHeight && st > buffer) { // Aggiunto controllo per buffer
                mainNav.style.top = "0%";
                mainNav.classList.add('bg-light');
            }
        }
    
        if (st <= buffer) {  // Modificato da st === 0 a st <= buffer per gestire il buffer
            mainNav.style.top = "0%";
            mainNav.classList.remove('bg-light');
        }
    
        lastScrollTop = st;
    }
    
    window.addEventListener('scroll', handleScroll);
    
    
    

    $(".overlay-menu li").each(function (index) {
      $(this).css({
        "animation-delay": "0." + 1 * index + "s",
      });
    });

    const swiper = new Swiper(".swiper", {
      // Optional parameters
      slidesPerView: 1.2,
      spaceBetween: 15,
      loop: false,
      mousewheel: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerView: 2.1,
        },
      },
    });

    const swiper_shop = new Swiper(".gallery-shop", {
      modules: [Navigation],
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      mousewheel: false,
      centeredSlides: true,
      centeredSlidesBounds: true,

      pagination: {
        el: ".swiper-pagination",
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    function load_video(cont_ID, videourl_mp4) {
      var video_mp4 = videourl_mp4; // set the url to your video file here

      var videocontainer = $(cont_ID); // set the ID of the container that you want to insert the video in

      var video_source = '<source src="' + video_mp4 + '"type="video/mp4">';

      $(videocontainer).append(video_source); // insert the video element into its container
      //
      var videl = $(document).find(videocontainer); // find the newly inserterd video
      //
      videl.load(); // load the video (it will autoplay because we've set it as a parameter of the video)
    }

    if ($("#videoAutoplay").length != 0) {
      var screenWidth = $(window).width();
      if (screenWidth < 720) {
        load_video(
          "#videoAutoplay",
          document
            .getElementById("videoAutoplay")
            .getAttribute("data-mobilevideo")
        );
      } else {
        load_video(
          "#videoAutoplay",
          document
            .getElementById("videoAutoplay")
            .getAttribute("data-desktopvideo")
        );
      }
    }
  });
})(jQuery);
